<script>
	import { state } from "../store";
	import { action } from "../api";
	import XIcon from "../assets/x.svg";
	import CheckmarkIcon from "../assets/checkmark.svg";

	$: game = $state.game;
	$: question = game.question;
	$: me = $state.players.find((player) => {
		return player.isYou;
	});

	$: options = question.options;
	$: currentOptionIndex = 0;

	let solved = false;
	let correctAnswers = [];
	let falseAnswers = [];
	let solution = { correctAnswers, falseAnswers };

	let solutionUpdateScheduled = false;

	const compareSolutions = (solution1, solution2) => {
		return solution1.correctAnswers.length === solution2.correctAnswers.length &&
			solution1.falseAnswers.length === solution2.falseAnswers.length;
	};

	const updateSolution = () => {
		solution = { correctAnswers, falseAnswers };
		if (!solutionUpdateScheduled && me && (typeof me.solution !== "object" || !compareSolutions(me.solution, solution))) {
			solutionUpdateScheduled = true;
			setTimeout(() => {
				solutionUpdateScheduled = false;
				action("solution", solution, "", solved);
			}, 500);
		}
	}

	const checkAnswer = (yes) => {
		return () => {
			const currentOption = options[currentOptionIndex];
			let regex = null;
			try {
				regex = new RegExp(question.regex, question.flags);
			}
			catch {}

			const isMatch = regex.test(currentOption);

			if ((yes && isMatch) || (!yes && !isMatch)) {
				correctAnswers = [
					...correctAnswers,
					{
						text: currentOption,
						matched: isMatch,
					}
				];
			}
			else {
				falseAnswers = [
					...falseAnswers,
					{
						text: currentOption,
						matched: isMatch,
					}
				];
			}

			if (options.length > currentOptionIndex + 1) {
				currentOptionIndex++;
			}
			else {
				solved = true;
				options = null;
			}

			updateSolution();
		};
	}
</script>

<div class="questionContainer">
	<div class="option">
		{#if options && !solved}
			<div class="question">
				/{question.regex}/{question.flags}<span class="smallText">&nbsp;.test(&nbsp;</span>{options[currentOptionIndex]}<span class="smallText">&nbsp;)&nbsp;</span>
			</div>
			<div class="buttonContainer">
				<div class="readQuestionIconContainer" on:click={checkAnswer(true)}><CheckmarkIcon /></div>
				<div class="readQuestionIconContainer" on:click={checkAnswer(false)}><XIcon /></div>
			</div>
		{:else}
			<div class="question">
				/{question.regex}/{question.flags}
			</div>
		{/if}
	</div>
	<div class="answers">
		<div>
			<div class="answerTitle">
				Corrects
			</div>
			{#each correctAnswers as { text, matched }}
				<div class={"answer " + (matched ? "matched" : "nonMatched")}>{text}</div>
			{/each}
		</div>
		<div class="matches">
			<div class="answerTitle">
				Incorrects
			</div>
			{#each falseAnswers as { text, matched }}
				<div class={"answer " + (matched ? "matched" : "nonMatched")}>{text}</div>
			{/each}
		</div>
	</div>
</div>

<style>
	.question {
		font-family: var(--font-family-mono);
		font-size: 1.5em;
		font-weight: bold;
		margin-bottom: 40px;
	}

	.smallText {
		font-size: 0.5em;
	}

	.questionContainer {
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: left;

		font-size: 1.2em;
	}

	.answers {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		text-align: left;

		font-size: 1.2em;
	}

	.option {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		margin-bottom: 40px;
	}

	.answerTitle {
		font-weight: bold;
		margin-bottom: 20px;
	}

	.answer {
		font-family: var(--font-family-mono);
		text-align: center;
		margin-bottom: 4px;
	}

	.buttonContainer {
		display: flex;
	}

	.readQuestionIconContainer {
		cursor: pointer;

		margin-left: 40px;
		margin-right: 40px;
	}

	:global(.readQuestionIconContainer svg) {
		height: 40px;
	}

	.matched {
		color: var(--green);
	}

	.nonMatched {
		color: var(--red);
	}
</style>